import { FC } from 'react';

import { Question } from '~src/interfaces/question.interface';
import { ContentLocalesI } from '~src/interfaces/session.types';
import { translateContent } from '~src/services/translationServices';
import { Topic } from '~src/interfaces/topic.interface';

import { EditCustomQuestion } from './edit/topicQuestions.sc';
import ListAddForm from './ListAddForm';

interface Props {
  resetQuestionEdit: () => void;
  onEdit?: (value: string | null, question: Question) => Promise<{}>;
  onDelete?: (questionId: string, name: ContentLocalesI | null) => Promise<{}>;
  topic: Topic;
  editQuestion: string | null;
}

const ListEditForm: FC<Props> = (props) => {
  function deleteQuestionEdit(): Promise<void> {
    return new Promise((res, rej) => {
      if (props.onDelete && props.editQuestion) {
        const questionName = questionInEdit ? questionInEdit.title : null;
        props
          .onDelete(props.editQuestion, questionName)
          .then(() => {
            props.resetQuestionEdit();
            res();
          })
          .catch(rej);
      } else {
        res();
      }
    });
  }

  const questionInEdit = props.topic.questions
    ? props.topic.questions.find((question) => question.id === props.editQuestion)
    : null;

  function submitHook(value: string) {
    return new Promise<void>((res, rej) => {
      if (props.onEdit && questionInEdit) {
        props
          .onEdit(value, questionInEdit)
          .then(() => {
            res();
            props.resetQuestionEdit();
          })
          .catch((err) => {
            rej(err);
          })
          .finally(() => {
            res();
          });
      }
    });
  }

  return (
    <EditCustomQuestion>
      <ListAddForm
        inputLabelKey="x.survey.list.edit.input.label"
        buttonTextKey="x.survey.list.edit.button"
        addTextKey="SUBMIT_REPLACE"
        submitForm={submitHook}
        openAndSelected
        initialValue={questionInEdit ? translateContent(questionInEdit.title) : undefined}
        onCancel={props.resetQuestionEdit}
        onDelete={deleteQuestionEdit}
      />
    </EditCustomQuestion>
  );
};

export default ListEditForm;
